import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { routes } from '~/constants';
import { isKnownOpportunityKind } from '~/utils/revenueOpportunities/opportunityLabels';
export const SEE_ALL_URL_STATE = {
    search: {},
    kind: {
        multi: true
    },
    service: {
        multi: true
    }
};
const encodeServiceKeys = (serviceKeys)=>serviceKeys.map(encodeURIComponent);
const decodedOrNothing = (encoded)=>{
    try {
        return [
            decodeURIComponent(encoded)
        ];
    } catch (unused) {
        return [];
    }
};
export const seeAllFiltersOf = (param)=>{
    let { search, kind, service } = param;
    return {
        search,
        kinds: kind.filter(isKnownOpportunityKind),
        serviceKeys: service.flatMap(decodedOrNothing)
    };
};
export const seeAllUrlChange = (param)=>{
    let { kinds, serviceKeys } = param;
    return _object_spread({}, kinds == null ? {} : {
        kind: [
            ...kinds
        ]
    }, serviceKeys == null ? {} : {
        service: encodeServiceKeys(serviceKeys)
    });
};
export const seeAllLink = (param)=>{
    let { kind, serviceKey } = param;
    const params = {
        kind,
        service: encodeServiceKeys([
            serviceKey
        ])[0]
    };
    return "".concat(routes.revenueOpportunities, "?").concat(new URLSearchParams(params).toString());
};
